/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BbsCategoryUpdateReqVo
 */
export interface BbsCategoryUpdateReqVo {
    /**
     * 韩文名字，必传
     * @type {string}
     * @memberof BbsCategoryUpdateReqVo
     */
    nameKr: string;
    /**
     * 中文名字，必传
     * @type {string}
     * @memberof BbsCategoryUpdateReqVo
     */
    nameCn: string;
    /**
     * 父级分类编号，不传时默认为空（表示最高级分类）;父级分类编号，当分类级别为 2 级时必传
     * @type {number}
     * @memberof BbsCategoryUpdateReqVo
     */
    parentId?: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof BbsCategoryUpdateReqVo
     */
    enable: number;
    /**
     * 是否只有登录后可见  0 不是 1 是
     * @type {number}
     * @memberof BbsCategoryUpdateReqVo
     */
    onlyLoginIn: number;
    /**
     * 排序
     * @type {number}
     * @memberof BbsCategoryUpdateReqVo
     */
    sort: number;
}

/**
 * Check if a given object implements the BbsCategoryUpdateReqVo interface.
 */
export function instanceOfBbsCategoryUpdateReqVo(value: object): value is BbsCategoryUpdateReqVo {
    if (!('nameKr' in value) || value['nameKr'] === undefined) return false;
    if (!('nameCn' in value) || value['nameCn'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('onlyLoginIn' in value) || value['onlyLoginIn'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    return true;
}

export function BbsCategoryUpdateReqVoFromJSON(json: any): BbsCategoryUpdateReqVo {
    return BbsCategoryUpdateReqVoFromJSONTyped(json, false);
}

export function BbsCategoryUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BbsCategoryUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'nameKr': json['nameKr'],
        'nameCn': json['nameCn'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'enable': json['enable'],
        'onlyLoginIn': json['onlyLoginIn'],
        'sort': json['sort'],
    };
}

export function BbsCategoryUpdateReqVoToJSON(json: any): BbsCategoryUpdateReqVo {
    return BbsCategoryUpdateReqVoToJSONTyped(json, false);
}

export function BbsCategoryUpdateReqVoToJSONTyped(value?: BbsCategoryUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nameKr': value['nameKr'],
        'nameCn': value['nameCn'],
        'parentId': value['parentId'],
        'enable': value['enable'],
        'onlyLoginIn': value['onlyLoginIn'],
        'sort': value['sort'],
    };
}

